import { Link } from "react-router-dom";

const footerLinks = {
  内容分类: [
    { label: "精选推荐", href: "/category/jingxuan-tuijian" },
    { label: "深度评测", href: "/category/shendu-pingce" },
    { label: "独家发现", href: "/category/dujia-faxian" },
    { label: "品质生活", href: "/category/pinzhi-shenghuo" },
    { label: "科技数码", href: "/category/keji-shuma" },
    { label: "文化阅读", href: "/category/wenhua-yuedu" },
  ],
  关于我们: [
    { label: "品牌故事", href: "/about" },
    { label: "联系我们", href: "/about#contact" },
    { label: "常见问题", href: "/about#faq" },
  ],
  关注我们: [
    { label: "微信公众号：探花精选", href: "#" },
    { label: "微博：@探花精选官方", href: "#" },
    { label: "邮箱：hello@pkgogo.cn", href: "#" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flower-line text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-foreground-900">
                探花精选
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              精品内容一站汇聚。为您甄选最优质的内容与资源，节省筛选时间，直达高价值信息。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 探花精选. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}